<div class="flex flex-col justify-center h-full">
  <div class="text-left">
    <a
      (click)="cancelEvent.emit()"
      class="cursor-pointer inline-flex text-decoration-none items-center body-medium text-interaction-dark mb-4"
    >
      <i class="fa-light fa-chevron-left"></i>
      <span [innerText]="'Common.Back' | translate" class="text-underlined pl-2"></span>
    </a>
  </div>
  <div class="flex-responsive items-center gap-4 mb-4">
    <i class="text-3xl text-decoration-dark fa-kit fa-email"></i>
    <div [innerText]="'LogIn.PleaseCheckYourEmailInbox' | translate" class="body-large text-left text-decoration-dark"></div>
  </div>
  <div class="well">
    <p [innerHtml]="'Onboarding.WeHaveSentAnEmail' | translate: { email: email }" class="body-medium mb-2"></p>
    <p [innerText]="'Onboarding.FollowTheLinkToSignUp' | translate" class="body-medium"></p>
  </div>
  <div [innerText]="'Common.Or' | translate" class="separator my-4"></div>
  <arivo-verification-code-input [redirectUrl]="'/onboarding/finish'" />
  <div class="mt-4">
    <p class="body-medium">
      <span [innerText]="'LogIn.HaveNotReceivedAnEmail' | translate"></span>
      <span>&nbsp;</span>
      <a
        (click)="sendAgainEvent.emit()"
        [innerText]="'LogIn.SendAgain' | translate"
        class="hover:text-interaction-light text-interaction no-underline cursor-pointer"
      ></a>
    </p>
  </div>
</div>
